export default __webpack_public_path__ + "static/media/card-masters-default.0332caae.png";